// Mirrors PhoenixCapital.Core.Common.PhoneNumberHelper. Inputs starting with
// '+' are parsed as international (E.164); everything else is parsed against
// the default region (US).

import { PhoneNumberUtil } from "google-libphonenumber";

const util = PhoneNumberUtil.getInstance();
const DEFAULT_REGION = "US";

export function isValidPhone(
  input: string | null | undefined,
  region: string = DEFAULT_REGION
): boolean {
  if (input == null) return false;
  const trimmed = input.trim();
  if (trimmed.length === 0) return false;
  try {
    const parsed = util.parse(trimmed, region);
    return trimmed.startsWith("+")
      ? util.isValidNumber(parsed)
      : util.isValidNumberForRegion(parsed, region);
  } catch {
    return false;
  }
}

export function phoneFieldError(
  input: string | null | undefined,
  { required }: { required: boolean } = { required: false }
): string | undefined {
  const trimmed = (input ?? "").trim();
  if (trimmed.length === 0) {
    return required ? "Phone number is required." : undefined;
  }
  return isValidPhone(trimmed) ? undefined : "Enter a valid phone number.";
}
